export default __webpack_public_path__ + "static/media/gemIcon.0c9000e7.svg";